/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Toolbar,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { LocalOffer as OfferIcon } from '../icons';
import { Event as EventIcon } from '../icons';
import { DirectionsCar as DirectionsCarIcon } from '../icons';
import { Flight as FlightIcon } from '../icons';
import { DeliveryDining as DeliveryDiningIcon } from '../icons';
import { Groups as GroupsIcon } from '../icons';
import { Map as MapIcon } from '../icons';
import { Forum as ForumIcon } from '../icons';
import { Search as SearchIcon } from '../icons';
import { Close as CloseIcon } from '../icons';
import { FilterList as FilterListIcon } from '../icons';

import { Link } from 'react-router-dom';
import { barColors } from '../theme';
import { pageContentSx, DESKTOP_MEDIA_QUERY } from '../pageLayout';
import { useDesktopSidebar } from '../desktopSidebarContext';

// isSearchOpen/onToggleSearch/onOpenFilters son opcionales: home.js y
// events.js los pasan para mostrar los íconos de buscar y filtros acá
// (mobile), a la derecha de los íconos de categoría, separados por un
// borde. Si no se pasan (p.ej. Hilos.js), ese bloque no se renderiza.
// showSearchFilters: la pantalla avisa si su layout ancho (panel de filtros
// al costado) no está activo y entonces hacen falta esos íconos acá; por
// defecto, solo debajo de DESKTOP_MEDIA_QUERY.
//
// Con la sidebar de escritorio las categorías ya están en ella, así que acá
// solo quedan (si corresponden) los íconos de buscar/filtros.
const CustomToolbar = ({ isSearchOpen, onToggleSearch, onOpenFilters, showSearchFilters }) => {
  const sidebarActive = useDesktopSidebar();
  const theme = useTheme();
  // En desktop, Hilos ya tiene su propio acceso directo (el botón central
  // del bottom nav, ver BottomToolbar.js), así que este ícono va derecho al
  // mapa. En mobile ese botón central sigue yendo a QRScanner, así que acá
  // van Mapa e Hilos como dos íconos separados.
  const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY);
  const searchFiltersVisible =
    (showSearchFilters ?? !isDesktop) && !!(onToggleSearch || onOpenFilters);

  const styles = {
    toolbar: {
      backgroundColor: sidebarActive ? 'transparent' : barColors.background,
      color: sidebarActive ? 'inherit' : barColors.text,
    },
    iconRow: {
      ...pageContentSx,
      display: 'flex',
      alignItems: 'center',
      // Íconos + buscar/filtros como un solo grupo centrado bajo el logo.
      justifyContent: 'center',
    },
    categoryIcons: {
      display: sidebarActive ? 'none' : 'flex',
      justifyContent: 'center',
    },
    searchFilterIcons: {
      display: 'flex',
      alignItems: 'center',
      borderLeft: sidebarActive ? 'none' : `1px solid ${barColors.border}`,
      ml: sidebarActive ? 'auto' : 1.5,
      pl: sidebarActive ? 0 : 1.5,
    },
    iconButton: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
    },
    menuItemIcon: {
      marginRight: '8px',
    },
    divider: {
      height: 34,
      margin: '14px 0',
    },
  };

  if (sidebarActive && !searchFiltersVisible) return null;

  return (
    <Toolbar sx={styles.toolbar}>
      <Box sx={styles.iconRow}>
        <Box sx={styles.categoryIcons}>
          <IconButton id="tour-etiqueta" component={Link} to="/home" color="inherit" sx={styles.iconButton}>
            <OfferIcon />
          </IconButton>

          <IconButton id="tour-calendario" component={Link} to="/events" color="inherit" sx={styles.iconButton}>
            <EventIcon />
          </IconButton>

          {isDesktop && (
            <IconButton id="tour-map" component={Link} to="/map" color="inherit" sx={styles.iconButton}>
              <GroupsIcon />
            </IconButton>
          )}

          <IconButton id="tour-auto" component={Link} to="/cars" color="inherit" sx={styles.iconButton}>
            <DirectionsCarIcon />
          </IconButton>

          <IconButton id="tour-avion" component={Link} to="/trips" color="inherit" sx={styles.iconButton}>
            <FlightIcon/>
          </IconButton>

          <IconButton component={Link} to="/pedidos" color="inherit" sx={styles.iconButton} aria-label="Pedidos">
            <DeliveryDiningIcon />
          </IconButton>

          {!isDesktop && (
            <>
              <IconButton id="tour-map" component={Link} to="/map" color="inherit" sx={styles.iconButton}>
                <MapIcon />
              </IconButton>
              <IconButton component={Link} to="/hilos" color="inherit" sx={styles.iconButton}>
                <ForumIcon />
              </IconButton>
            </>
          )}
        </Box>

        {searchFiltersVisible && (
          <Box sx={styles.searchFilterIcons}>
            {onToggleSearch && (
              <IconButton color="inherit" onClick={onToggleSearch}>
                {isSearchOpen ? <CloseIcon /> : <SearchIcon />}
              </IconButton>
            )}
            {onOpenFilters && (
              <IconButton color="inherit" onClick={onOpenFilters}>
                <FilterListIcon />
              </IconButton>
            )}
          </Box>
        )}
      </Box>
    </Toolbar>
  );
};

export default CustomToolbar;